import React from 'react'

import {
  Card,
  Grid,
  Typography,
  Box,
  Button,
  Collapse,
  Tooltip,
  Fade,
  IconButton,
  ToggleButtonGroup,
  ToggleButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  FormControlLabel,
  Switch,
} from '@mui/material'

import { useContext, useState, useEffect } from 'react'

import ValuePoint from 'admin/components/ValuePoint'
import { BalanceSheetRow } from 'layouts/authenticated/pages/dashboard/components/BalanceSheet/BalanceSheetRow'
import { ExpandMore, MoreVert } from '@mui/icons-material'
import UserGoals from 'admin/components/UserGoals'
import FormField from 'components/FormField'
import { MenuItem } from '@aws-amplify/ui-react'
import { LeaveAndEarnings } from 'layouts/authenticated/pages/dashboard/components/LeaveAndEarnings'
import RetirementGapTable from 'layouts/authenticated/pages/newdash/components/RetirementGapTable'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

function IncomeStatement({
  collapseSections,
  toggleCollapse,
  adjustedNetTakeHomeDifferencePARCOGap,
  deductions,
  liabilities,
  incomes,
  expenses,
  readinessScoreAdjustedMax,
  intakeState,
  getAccounts,
}) {
  const [tableTimeHorizon, setTableTimeHorizon] = useState('monthly')
  const switchTimeHorizon = (event, newTimeHorizon) => {
    newTimeHorizon === null
      ? setTableTimeHorizon('monthly')
      : setTableTimeHorizon(newTimeHorizon)
  }

  const [anchorEl, setAnchorEl] = useState(null)
  const tableMenuOpen = Boolean(anchorEl)
  const handleTableMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleTableMenuClose = () => {
    setAnchorEl(null)
  }
  const [tableStates, setTableStates] = useState({
    values: false,
    expand: false,
    paycheck: false,
    working: false,
    difference: false,
  })
  const handleTableStateChange = (event) => {
    setTableStates({
      ...tableStates,
      [event.target.name]: event.target.checked,
    })
  }
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.incomeStatement}
                style={{ width: '100%' }}
              ></Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="incomestatement"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('incomeStatement')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Income Statement
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.incomeStatement
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse
            in={collapseSections.incomeStatement}
            style={{ width: '100%' }}
          >
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              {/* <Grid item xs={12}>
                <LeaveAndEarnings
                  deductions={deductions}
                  liabilities={liabilities}
                  incomes={incomes}
                  expenses={expenses}
                  readinessScoreAdjustedMax={readinessScoreAdjustedMax}
                  tableTimeHorizon={tableTimeHorizon}
                  tableStates={tableStates}
                />
              </Grid> */}
              <Grid item xs={12}>
                <RetirementGapTable
                  retirementGap={Math.abs(
                    adjustedNetTakeHomeDifferencePARCOGap
                  )}
                  intakeState={intakeState}
                  deductions={deductions}
                  liabilities={liabilities}
                  incomes={incomes}
                  expenses={expenses}
                  getAccounts={getAccounts}
                  dashboardVersion={
                    intakeState?.retirementLifestyleGoal?.lifestyleGoal
                      ? true
                      : false
                  }
                  retirementLifestyleGoal={
                    intakeState?.retirementLifestyleGoal?.lifestyleGoal || 1
                  }
                  lifeStyleClickAction={() => {
                    // openModal('lifestyleGoal', {
                    //   adjustedWorkingNetTakeHome: adjustedWorkingNetTakeHome,
                    //   adjustedNetTakeHomeInRetirement:
                    //     adjustedNetTakeHomeInRetirement,
                    //   adjustedNetTakeHomeDifferencePARCOGap:
                    //     adjustedNetTakeHomeDifferencePARCOGap,
                    //   valueOfInvestableAssets: valueOfInvestableAssets,
                    //   parcoAnnuityRecommendationCalculator:
                    //     parcoAnnuityRecommendationCalculator,
                    // })
                  }}
                  lifeStyleStyling={true}
                />
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default IncomeStatement
